/**
 * Every id in this layer is a string, but several list endpoints type their
 * id-array filters as numbers on the wire. This is the one place that
 * conversion happens.
 *
 * An empty array becomes `undefined` rather than an empty param, so an
 * unset filter is absent from the query string instead of present and empty.
 * Unparseable ids are dropped: they can only come from a hand-edited URL, and
 * sending `NaN` would 400 the whole list rather than ignore one bad filter.
 */
export function toWireIds(ids: readonly string[] | undefined): number[] | undefined {
  if (ids == null || ids.length === 0) {
    return undefined;
  }
  const parsed = ids.map(Number).filter((n) => Number.isFinite(n));
  return parsed.length > 0 ? parsed : undefined;
}
